import React from 'react';
import A from '../images/drawing__finish-button.png';
import HoverA from '../images/drawing__finish-button--hover.png';
import B from '../images/sp/drawing__finish-button.png';

type P = {
    onClick: () => void;
    mobile: boolean;
};

export const ConfirmButton = (props: P) => {

    // event handler

    const onClick = () => {
        props.onClick();
    };

    // render

    // {/*<button onClick={onClick}>confirm button</button>*/}
    return props.mobile ?
        (<img className='drawing-page__finish-button' src={B} onClick={onClick} width='192' height='65' alt=''/>) :
        (<img
            className='drawing-page__finish-button'
            src={A}
            onClick={onClick}
            onMouseOver={e=>e.currentTarget.src=HoverA}
            onMouseOut={e=>e.currentTarget.src=A}
            width='218' height='100' alt=''/>);
};